import * as e from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/BellRinging.es.js";
const o = e.forwardRef((n, i) => /* @__PURE__ */ e.createElement(r, { ref: i, ...n, weights: t }));
o.displayName = "BellRingingIcon";
const m = o;
export {
  m as BellRinging,
  o as BellRingingIcon
};
